import { useLocation } from "wouter";
import { useAuth } from "@/hooks/use-auth";
import { useSettings } from "@/contexts/SettingsContext";
import { Button } from "@/components/ui/button";
import { SettingsSection } from "@/components/settings/SettingsSection";

export function AccountSettings() {
  const { user, logout } = useAuth();
  const { closeSettings } = useSettings();
  const [, navigate] = useLocation();

  const handleSignOut = async () => {
    await logout();
    closeSettings();
    navigate("/auth");
  };

  if (!user) {
    return (
      <p className="py-8 text-center text-sm text-muted-foreground">
        You are not signed in.
      </p>
    );
  }

  return (
    <div className="space-y-6">
      <SettingsSection
        title="Account"
        description="Signed in on this device."
      >
        <dl className="overflow-hidden divide-y divide-border rounded-xl border border-border">
          <div className="flex items-baseline justify-between gap-4 px-4 py-3">
            <dt className="text-sm text-muted-foreground">Email</dt>
            <dd className="truncate text-right text-sm font-medium">
              {user.email}
            </dd>
          </div>
          {(user.username || user.email) && (
            <div className="flex items-baseline justify-between gap-4 px-4 py-3">
              <dt className="text-sm text-muted-foreground">Username</dt>
              <dd className="truncate text-right text-sm font-medium">
                {user.username || user.email}
              </dd>
            </div>
          )}
          {user.created_at && (
            <div className="flex items-baseline justify-between gap-4 px-4 py-3">
              <dt className="text-sm text-muted-foreground">Member since</dt>
              <dd className="text-sm font-medium">
                {new Date(user.created_at).toLocaleDateString()}
              </dd>
            </div>
          )}
        </dl>
      </SettingsSection>

      <Button type="button" variant="destructive" onClick={() => void handleSignOut()}>
        Sign out
      </Button>
    </div>
  );
}
